var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseEvent } from './base-event';
/**
 * Arguments for the `plotAreaClick` event.
 */
var PlotAreaClickEvent = /** @class */ (function (_super) {
    __extends(PlotAreaClickEvent, _super);
    /**
     * @hidden
     */
    function PlotAreaClickEvent(e, target) {
        var _this = _super.call(this, target) || this;
        _this.category = e.category;
        _this.nativeEvent = e.originalEvent;
        _this.value = e.value;
        _this.x = e.x;
        _this.y = e.y;
        return _this;
    }
    return PlotAreaClickEvent;
}(BaseEvent));
export { PlotAreaClickEvent };
//# sourceMappingURL=plot-area-click-event.js.map